import { supabase } from "@/integrations/supabase/client";
import { useState, useRef } from "react";

interface UserProfile {
  id: string;
  name: string | null;
  email: string | null;
  telefone: string | null;
  cpf: string | null;
  empresa_id: number | null;
  nivel: number | null;
  foto_perfil_url: string | null;
  created_at: string;
  empresas?: {
    nome_fantasia: string | null;
    razao_social: string | null;
  } | null;
}

export const useProfileUtils = () => {
  const [adminStatus, setAdminStatus] = useState<boolean | null>(null);
  const checkingRef = useRef<string | null>(null);

  const checkAdminStatus = async (userId: string) => {
    try {
      const { data, error } = await supabase.rpc("is_admin", {
        user_id: userId,
      });
      if (error) {
        console.error("Error checking admin status:", error);
        return false;
      }
      return data || false;
    } catch (error) {
      console.error("Exception checking admin status:", error);
      return false;
    }
  };

  const isAdmin = (profile: UserProfile | null) => {
    // Synchronous check: nivel === 1 indicates admin
    if (profile?.nivel === 1) return true;

    // If we have cached async result, use it
    if (profile?.id && adminStatus !== null) {
      return adminStatus;
    }

    // Trigger async check only if not already in progress for this profile
    if (profile?.id && checkingRef.current !== profile.id) {
      checkingRef.current = profile.id;
      checkAdminStatus(profile.id).then((result) => {
        setAdminStatus(result);
        checkingRef.current = null;
      });
    }

    return false;
  };

  const getEmpresaName = (
    profile: UserProfile | null,
    isEmpresaLoading: boolean
  ) => {
    if (isAdmin(profile)) {
      return "Administrador";
    }

    if (!profile?.empresa_id) {
      return "Empresa não definida";
    }

    if (profile?.empresas) {
      const empresaName =
        profile.empresas.nome_fantasia || profile.empresas.razao_social;
      return empresaName || "Não informado";
    }

    return "Não informado";
  };

  return {
    isAdmin,
    getEmpresaName,
  };
};
